export default "__VITE_ASSET__Cbpyu0Zc__";